// src/services/api/procurement/grn.js
// Endpoints per rettzy-backend/src/modules/procurement/routes/grn.routes.js
import { apiClient } from '../base';

export const getGoodsReceivedNotes = async (params = {}) => {
  const response = await apiClient.get('/procurement/grn', { params });
  return response.data;
};

export const getGoodsReceivedNote = async (grnId) => {
  const response = await apiClient.get(`/procurement/grn/${grnId}`);
  return response.data;
};

export const createGoodsReceivedNote = async (data) => {
  const response = await apiClient.post('/procurement/grn', data);
  return response.data;
};

export const cancelGoodsReceivedNote = async (grnId, data) => {
  const response = await apiClient.post(`/procurement/grn/${grnId}/cancel`, data);
  return response.data;
};

// "Receive Order" — receives the entire remaining quantity of a PO in one GRN.
// Not wired into any UI yet (Phase 11's job, per procurementImplementationPhases.md) —
// added here now since §9.7 asks for the full GRN service surface in this phase.
export const receiveEntirePurchaseOrder = async (purchaseOrderId) => {
  const response = await apiClient.post(`/procurement/purchase-orders/${purchaseOrderId}/receive-full`);
  return response.data;
};
